import { palette } from '@/core/theme/palette'

const { light: L, dark: D } = palette

const rgba = (rgb, a) => `rgba(${rgb}, ${a})`

function buildButtonTheme(p) {
  return {
    borderRadiusTiny: '6px',
    borderRadiusSmall: '8px',
    borderRadiusMedium: '10px',
    borderRadiusLarge: '10px',
    heightTiny: '28px',
    heightSmall: '32px',
    heightMedium: '40px',
    heightLarge: '44px',
    fontWeight: '500',
    opacityDisabled: '0.55',
    border: `1px solid ${p.border}`,
    borderHover: `1px solid ${p.primary}`,
    borderPressed: `1px solid ${p.primaryPressed}`,
    borderFocus: `1px solid ${p.primary}`,
    borderDisabled: `1px solid ${p.border}`,
    color: p.panelBg,
    colorHover: rgba(p.primaryRgb, 0.12),
    colorPressed: rgba(p.primaryRgb, 0.18),
    colorFocus: rgba(p.primaryRgb, 0.12),
    textColor: p.textPrimary,
    textColorHover: p.primary,
    textColorPressed: p.primaryPressed,
    textColorFocus: p.primary,
    borderPrimary: `1px solid ${p.primary}`,
    borderHoverPrimary: `1px solid ${p.primaryHover}`,
    borderPressedPrimary: `1px solid ${p.primaryPressed}`,
    borderFocusPrimary: `1px solid ${p.primary}`,
    colorPrimary: rgba(p.primaryRgb, 0.08),
    colorHoverPrimary: p.primary,
    colorPressedPrimary: p.primaryPressed,
    colorFocusPrimary: rgba(p.primaryRgb, 0.14),
    textColorPrimary: p.primary,
    textColorHoverPrimary: '#FFFCF8',
    textColorPressedPrimary: '#FFFCF8',
    textColorFocusPrimary: p.primary,
    borderInfo: `1px solid ${p.info}`,
    colorInfo: rgba(p.primaryRgb, 0.06),
    colorHoverInfo: p.info,
    textColorInfo: p.info,
    textColorHoverInfo: '#FFFCF8',
    borderSuccess: '1px solid #5a8f6e',
    colorSuccess: 'rgba(90, 143, 110, 0.1)',
    colorHoverSuccess: '#5a8f6e',
    textColorSuccess: '#5a8f6e',
    textColorHoverSuccess: '#ffffff',
    borderWarning: '1px solid #c4923a',
    colorWarning: 'rgba(196, 146, 58, 0.12)',
    colorHoverWarning: '#c4923a',
    textColorWarning: '#a67c32',
    textColorHoverWarning: '#ffffff',
    borderError: '1px solid #b85c5c',
    colorError: 'rgba(184, 92, 92, 0.1)',
    colorHoverError: '#b85c5c',
    textColorError: '#b85c5c',
    textColorHoverError: '#ffffff',
    borderTertiary: `1px solid ${p.border}`,
    colorTertiary: p.panelBg,
    colorHoverTertiary: rgba(p.primaryRgb, 0.1),
    textColorTertiary: p.textPrimary,
    textColorHoverTertiary: p.primary,
    colorQuaternary: p.panelBg,
    colorHoverQuaternary: rgba(p.primaryRgb, 0.1),
    textColorQuaternary: p.textSecondary,
    textColorHoverQuaternary: p.primary
  }
}

const shared = {
  common: {
    primaryColor: L.primary,
    primaryColorHover: L.primaryHover,
    primaryColorPressed: L.primaryPressed,
    primaryColorSuppl: L.primarySuppl,
    borderRadius: '8px',
    borderRadiusSmall: '6px',
    fontWeightStrong: '500',
    boxShadow2: `0 4px 16px rgba(${L.shadowRgb}, 0.08)`,
    boxShadow3: `0 8px 28px rgba(${L.shadowRgb}, 0.12)`
  },
  Button: buildButtonTheme(L),
  Input: {
    borderRadius: '10px',
    heightSmall: '32px',
    heightMedium: '40px',
    heightLarge: '44px',
    boxShadowFocus: `0 0 0 2px ${rgba(L.primaryRgb, 0.2)}`
  },
  Card: {
    borderRadius: '12px',
    paddingMedium: '10px 14px'
  },
  Tree: {
    nodeColorActive: rgba(L.primaryRgb, 0.14),
    nodeColorHover: rgba(L.primaryRgb, 0.08),
    nodeBorderRadius: '8px',
    fontSize: '14px'
  },
  Avatar: {
    borderRadius: '10px'
  },
  Dialog: {
    borderRadius: '12px'
  },
  Popover: {
    borderRadius: '10px'
  }
}

export const lightThemeOverrides = {
  ...shared,
  Card: {
    ...shared.Card,
    colorEmbedded: L.panelBg
  },
  Layout: {
    color: L.panelBg,
    siderColor: L.panelBg
  }
}

export const darkThemeOverrides = {
  ...shared,
  common: {
    ...shared.common,
    primaryColor: D.primary,
    primaryColorHover: D.primaryHover,
    primaryColorPressed: D.primaryPressed,
    primaryColorSuppl: D.primarySuppl,
    boxShadow2: '0 4px 16px rgba(0, 0, 0, 0.35)',
    boxShadow3: '0 8px 28px rgba(0, 0, 0, 0.45)'
  },
  Button: buildButtonTheme(D),
  Input: {
    ...shared.Input,
    boxShadowFocus: `0 0 0 2px ${rgba(D.primaryRgb, 0.22)}`
  },
  Card: {
    ...shared.Card,
    colorEmbedded: D.panelBg
  },
  Layout: {
    color: '#1a1816',
    siderColor: D.panelBg
  },
  Tree: {
    ...shared.Tree,
    nodeColorActive: rgba(D.primaryRgb, 0.22),
    nodeColorHover: rgba(D.primaryRgb, 0.12)
  }
}

/** @deprecated 使用 lightThemeOverrides */
export const themeOverrides = lightThemeOverrides
